/**
 * Serpix service-worker registration.
 * Only runs in production builds. In dev (webpack-dev-server) SW registration
 * is intentionally disabled — otherwise HMR would serve stale bundles.
 *
 * Also unregisters any previously-installed SW when NODE_ENV !== production
 * to guarantee a clean dev experience.
 */

const isLocalhost = Boolean(
  typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname))
);

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  // Dev / localhost — make sure any leftover SW is removed.
  if (process.env.NODE_ENV !== "production" || isLocalhost) {
    navigator.serviceWorker.getRegistrations?.().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl, { scope: "/" })
      .then((reg) => {
        // If a new SW is waiting, activate it on the next tick.
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              newWorker.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        /* SW registration failure is non-fatal */
      });

    // Reload once when the active SW is swapped, so the new asset hashes load.
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
